<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="项目组" label-width="60">
          <ThrottleSelector
            v-model="projectId"
            :list="projectData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem label="人员" label-width="48">
          <ThrottleSelector
            v-model="agentId"
            :list="agentData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem label="游戏组" label-width="60">
          <ThrottleSelector
            v-model="groupId"
            :list="groupData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem label="媒体" label-width="48">
          <ThrottleSelector
            v-model="mediaId"
            :list="medias"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem label="月份" label-width="48">
          <ElDatePicker
            type="month"
            value-format="yyyy-MM"
            v-model="month"
            :picker-options="datetimeOption"
            :clearable="false"
            placeholder="不限"
            style="width: 100px"
          >
          </ElDatePicker>
        </ElFormItem>
      </ElForm>
    </div>

    <div class="btns-row"></div>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce, isArray } from '@/common/js/utils'
import { getAllUser } from '@/api/manage.model'
import { getPtomGroupGames, getPtomGames } from '@/api/material.model'
import ThrottleSelector from '@/components/throttle-select/index.vue'
export default {
  name: 'recordFilter',
  components: { ThrottleSelector },
  props: {
    medias: {
      type: Array,
      default() {
        return []
      }
    },
    projectData: {
      type: Array,
      default() {
        return []
      }
    },
    syncing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    authRecord() {
      // const authIds = this.access.filter(ret => ret.value).map(met => met.id)
      return this.access.includes('M20822')
    },
    authLock() {
      // const authIds = this.access.filter(ret => ret.value).map(met => met.id)
      return this.access.includes('M20824')
    }
  },
  methods: {
    sendEvent() {
      const params = {
        gameIdStr: this.gameIds.length ? this.gameIds.join(',') : undefined,
        mediaId: this.mediaId === '' ? undefined : this.mediaId,
        opId: this.agentId === '' ? undefined : this.agentId,
        gameGroupId: this.groupId === '' ? undefined : this.groupId,
        projectGroupId: this.projectId === '' ? undefined : this.projectId,
        reportMonth: this.month === '' ? undefined : this.month
      }
      this.$emit('on-change', params)
    },

    proloadData() {
      Promise.all([getAllUser(), getPtomGroupGames(), getPtomGames()])
        .then((data) => {
          const [ptomData, groupData, gameData] = data
          if (isArray(ptomData)) {
            this.agentData = ptomData.map((ret) => {
              return {
                id: ret.id,
                name: ret.name
              }
            })
          }
          if (isArray(groupData)) {
            this.groupData = groupData.map((ret) => {
              return {
                id: ret.groupId,
                name: ret.groupName
              }
            })
          }
          if (isArray(gameData)) {
            this.gameData = gameData.map((ret) => {
              return {
                id: ret.id,
                name: ret.name
              }
            })
          }
          // 初始化
          this.sendEvent()
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    }
  },
  watch: {
    month(nVal) {
      this.sendEvent()
      this.$emit('get-lock-state', this.month)
    }
  },
  data() {
    return {
      month: '', // 月份
      mediaId: '', // 媒体id
      agentId: '', // 人员id
      agentData: [],
      projectId: '',
      groupId: '',
      gameIds: [],
      groupData: [],
      gameData: [],
      lock: null,
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      },
      access: this.$store.state.accessAuth
    }
  },
  created() {
    this.month = moment().subtract(2, 'months').format('YYYY-MM')
    this.proloadData()
  }
}
</script>
<style lang="scss" scoped></style>
